.base {
  border: none;
  outline: none;
  padding: 20px;
  font-size: .9rem !important;
  line-height: 1.5;
  color: var(--text-dark);
  background-color: transparent;
  padding: 0;
  height: auto;
}

.base:disabled {
  opacity: .7;
}

.base:hover:not(:disabled) {
  color: var(--text-dark-alt);
}

.primary {
  color: var(--primary);
}

.primary:hover:not(:disabled) {
  color: var(--primary-hover);
}

.success {
  color: var(--success);
}

.success:hover:not(:disabled) {
  color: var(--success-hover);
}

.danger {
  color: var(--danger);
}

.danger:hover:not(:disabled) {
  color: var(--danger-hover);
}

.info {
  color: var(--info);
}

.info:hover:not(:disabled) {
  color: var(--info-hover);
}

.warning {
  color: var(--warning);
}

.warning:hover:not(:disabled) {
  color: var(--warning-hover);
}

.link {
  color: var(--link);
}

.link:hover:not(:disabled) {
  color: var(--link-hover);
}
